import { INamedEntity } from 'app/business-logic/services/types';
import Guid from 'core/types/Guid';
import { OdourCharacterType, OdourIntensityType } from 'app/__generated__/global';
import { DateTime } from 'luxon';
import { DISREGARD_ANNOTATION_TYPE_ID } from 'app/views/annotations/components/disregard-annotation/disregardAnnotation.constants';

export const AnnotationsType = {
  controlledTest: {
    id: 'cfa73c36-f2f3-4151-b74b-1368d7322e78',
    key: 'controlledTest',
    slug: 'controlled-test',
  },
  approximateExposure: {
    id: 'f1eec62e-415c-48ee-887f-643c88d0e68f',
    key: 'approximateExposure',
    slug: 'approximate-exposure',
  },
  fieldObservation: {
    id: '8a97f1e1-972e-43e4-bb5c-cd7101bae19b',
    key: 'fieldObservation',
    slug: 'field-observation',
  },
  odourObservation: {
    id: '9a33a39e-d21a-4532-adc6-23c6e42251e3',
    key: 'odourObservation',
    slug: 'odour-observation',
  },
  airQualityObservation: {
    id: 'e8dfb0e3-6bfd-4888-8953-28d5dbfd6fbd',
    key: 'airQualityObservation',
    slug: 'air-quality-observation',
  },
  disregard: {
    id: DISREGARD_ANNOTATION_TYPE_ID,
    key: 'disregard',
    slug: 'disregard',
  },
} as const;

export interface ICredentialActionTime {
  credentialId: Guid;
  username: string;
  time: string;
}

export interface IAnnotation {
  id: Guid;
  message?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  created: ICredentialActionTime | null;
  archived: ICredentialActionTime | null;
}

export interface IMonitorPollutantAnnotation {
  id: Guid;
  annotation: IAnnotation;
  concentration: number | null;
  pollutant: INamedEntity | null;
  monitor: INamedEntity;
  type: INamedEntity;
  odourCharacter: OdourCharacterType | null | undefined;
  odourIntensity: OdourIntensityType | null | undefined;
  unit: INamedEntity | null;
  numericRating?: number | null;
}

export interface IFlattenedMonitorPollutantAnnotation {
  message?: string | null;
  startTime?: DateTime | null;
  endTime?: DateTime | null;
  concentration: number | null;
  pollutantId: Guid | null;
  monitorId: Guid;
  typeId: Guid;
  unitId: Guid | null;
  odourCharacter: OdourCharacterType | null | undefined;
  odourIntensity: OdourIntensityType | null | undefined;
  archive: boolean;
  numericRating?: number | null;
}
